import request from '@lib/request'
// 获取素材内容列表
function AdminList() {
  return request
    .get('/institutionAdmin/institution/assignUserList', {
      params: {}
    })
    .then(result => {
      return result.data
    })
}
// 分配用户列表
function AdminSelectList() {
  return request
    .get('/institutionAdmin/institution/authUsers', {
      params: {}
    })
    .then(result => {
      return result.data
    })
}
// 确认分配
function NewUserSure({
  id,
  roal
}) {
  return request
    .post('/institutionAdmin/institution/addAuth', {
      uid: id,
      role_type: roal
    })
    .then(response => {
      return response.data
    })
}

function DelateAdmin({
  id
}) {
  return request
    .post('/institutionAdmin/institution/authDelete', {
      id
    })
    .then(response => {
      return response.data
    })
}

function ChangeWord({
  oldWord,
  newWord
}) {
  return request
    .post('/institutionAdmin/institution/changePassword', {
      ori_password: oldWord,
      new_password: newWord
    })
    .then(response => {
      return response.data
    })
}
// 重置密码
function EditWord({
  id,
  newWord
}) {
  return request
    .post('/institutionAdmin/institution/resetPassword', {
      id,
      reset_password: newWord
    })
    .then(response => {
      return response.data
    })
}
export default {
  AdminList,
  DelateAdmin,
  ChangeWord,
  EditWord,
  AdminSelectList,
  NewUserSure
}
